export enum AssetType {
  Template,
  Picture,
  Video,
  None,
}
